import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import {
  allowedRootTypesMap,
  searchAndFilterFolders,
  searchesOnlyFolders,
} from './constants';
import { EPlateState } from 'enums/EPlatestate';
import ETreeNodeAccessRightNames from 'enums/ETreeNodeAccessRightNames';
import EContainerType from 'enums/EContainerType';
import { EProductEditions } from 'enums/EProductEditions';

export const isPasteAllowedForRootNodes = (treeControlState, nodesToCopy) => {
  if (nodesToCopy.length === 0) {
    return false;
  }

  const selectedType = treeControlState.selectedNodes[0]?.type as ETreeNodeTypes;
  const allowedTypes = allowedRootTypesMap[selectedType];

  return allowedTypes
    ? nodesToCopy.every((node) => allowedTypes.includes(node.type as ETreeNodeTypes))
    : false;
};

export const isImageNowDisabled = (
  isRMLite,
  selectedNodes,
  productEdition: EProductEditions,
) => {
  return (
    isRMLite ||
    productEdition === EProductEditions.ExperimentDesigner ||
    !selectedNodes.every((node) => node.type === 'Experiment') ||
    selectedNodes.some((node) => node.extra?.plateState < EPlateState.Dispensed)
  );
};

export const isNewSnfDisabled = (
  selectedExplorerNode,
  isPlateViewerEdition: boolean = false,
  allowSearchUnderSearchesFolderOnly: boolean = false,
) => {
  const allowedFolders = allowSearchUnderSearchesFolderOnly
    ? searchesOnlyFolders
    : searchAndFilterFolders;

  return (
    selectedExplorerNode?.accessRightName !== ETreeNodeAccessRightNames.Modify ||
    !allowedFolders.includes(selectedExplorerNode?.type) ||
    !selectedExplorerNode?.allowEdits ||
    isPlateViewerEdition
  );
};

export const isLcpOrMicrofluidicsExperiment = (node): boolean => {
  return (
    node?.type === ETreeNodeTypes.Experiment &&
    (node?.extra?.containerType === EContainerType.LCP ||
      node?.extra?.containerType === EContainerType.Microfluidics)
  );
};
